import { BlurUtil } from "../../../../common/utils/blurUtil";
import { OrderStatus } from "../../../../objects/orders/orderStatus";
import { Router } from "@angular/router";
import { OrderSearch } from "../../../../objects/responses/orderSearch";
import { Order } from "../../../../objects/orders/order";

export class BaseOrderItemComponent{

    public goToDetailsBase(id: number, router: Router, orderSearch: OrderSearch, unblurId: any, order:  Order): void {
        router.navigate([`management/order`, {
            query: orderSearch.Query ? orderSearch.Query : "",
            agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
            customerid: orderSearch.CustomerID ? orderSearch.CustomerID.toString() : ""
        }]);

        BlurUtil.unBlurMenu(unblurId);

        router.navigate([`order/${id.toString()}`, {
            query: orderSearch.Query ? orderSearch.Query : "",
            agentid: orderSearch.AgentId ? orderSearch.AgentId.toString() : "",
            customerid: order.Customer && order.Customer.Id ? order.Customer.Id.toString() : ""
        }]);
    }

    public isMobile(): boolean {
        if (screen.width > 767)
            return false;

        return true;
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderItem/base-order-item.component.ts